export default [{
    path: 'point-group',
    component: () => import('@/views/dcim/point-group'),
    children: [{
        path: '',
        component: () => import('@/views/dcim/point-group/page')
    }, {
        path: 'page',
        components: { page: ()  => import('@/views/dcim/point-group/page') },
    }, {
        path: 'details',
        components: { details: () => import('@/views/dcim/point-group/details') },
    }]
}]
